module.exports = "/wp-content/themes/onnit/script/cart/dist/shroomUpsellBg-aaa45638.jpg";